<template>
  <div class="btnBubble">
    <div v-for="(item, idx) in hasBubbleButton(chatButtons)" :key="idx" @click="clickedCategory(item, messageType, chatIndex)" class="UXBubbleItem">
      <div v-if="item.type !== 'COUNSELOR_BUTTON'">
        <a
          v-show="item.type !== 'URL_BUTTON' && item.type !== 'TEL_BUTTON'"
          :class="{ on: scenarioData[chatIndex] === item.code }"
          v-html="item.text"
        >
        </a>
        <a
          v-if="item.type === 'URL_BUTTON' && item.url"
          :href="item.url"
          target="_blank"
          :class="{ on: scenarioData[chatIndex] === item.code }"
          v-html="item.text"
        >
        </a>
        <a
          v-if="item.type === 'TEL_BUTTON' && item.callNumber"
          :href="`tel:${item.callNumber}`"
          target="_blank"
          :class="{ on: scenarioData[chatIndex] === item.code }"
          v-html="item.text"
        >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BubbleButtonContents',
  props: ['chatIndex', 'messageType', 'clickedCategory', 'chatButtons', 'scenarioData'],
  methods: {
    hasBubbleButton(buttons) {
      return buttons ? buttons.filter((b) => b.type !== 'COUNSELOR_BUTTON') : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.btnBubble {
  padding: 20px 0px 0px 0px;
}
.UXBubbleItem {
  position: relative;
  margin: 0 10px 10px 0;
  padding: 10px 20px 10px 20px;
  word-break: break-all;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 35px;
  color: #2645b6;
  font-size: 14px;
  border-radius: 20px;
  border: 1px solid #cbcbcb;
  background: #fff;
  line-height: 20px; /* 142.857% */
  &:hover {
    color: var(--gray-gray-0, #fff);
    border: 1px solid #3c5fc8;
    background: #5578f0 !important;
    box-shadow: 0px 2px 5px 0px rgba(115, 115, 115, 0.3);
  }
}
</style>
